// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { isTouch } from '@trello/browser';
import { getKey, isArrow, Key } from '@trello/keybindings';
import { Util } from 'app/scripts/lib/util';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';

// Mixin
const AutoInsertionView = {
  checkInsert(e) {
    const key = getKey(e);

    if (PopOver.isVisible && !isTouch()) {
      if (
        (e.shiftKey && [Key.ArrowUp, Key.ArrowDown].includes(key)) ||
        (e.altKey && [Key.ArrowUp, Key.ArrowDown].includes(key))
      ) {
        return;
      } else if (key === Key.Escape) {
        stopPropagationAndPreventDefault(e);
        PopOver.hide();
        return;
      } else {
        const autoCompleters = [
          {
            listClass: '.js-available-members',
            itemClass: '.js-select-member',
          },
          { listClass: '.js-available-emoji', itemClass: '.js-select-emoji' },
          { listClass: '.js-card-list', itemClass: '.js-select-card' },
        ];

        for (const { listClass, itemClass } of Array.from(autoCompleters)) {
          let $available = $('.pop-over').find(listClass);
          if ($available.length > 0) {
            if ([Key.Enter, Key.Tab].includes(key)) {
              stopPropagationAndPreventDefault(e);
              // Make sure we've updated the list with everything we've typed
              if ($available.find('.item:first').hasClass('selected')) {
                this.keyAutoMention(e);
                // This might cause the list to re-write, so we have to get the
                // items back out of the DOM
                $available = $('.pop-over').find(listClass);
              }

              $available
                .find(`.item.selected:first ${itemClass}`)
                .first()
                .click();

              PopOver.hide();
              return false;
            } else if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
              stopPropagationAndPreventDefault(e);
              Util.navMenuList($available, '.item', key);
              return false;
            }
          }
        }
      }
    }
  },

  keyAutoMention(e) {
    if (!isTouch()) {
      if (isArrow(getKey(e)) || getKey(e) === Key.Enter) {
        return;
      }

      if (getKey(e) === Key.Escape) {
        if (PopOver.isVisible) {
          stopPropagationAndPreventDefault(e);
        }
        return;
      }

      const word = Util.getWordFromCaret(this.getTextInput());

      if (new RegExp(`^@\\S`).test(word.str.substring(0, 2))) {
        // Because the function that determines who to show is
        // locked up in the view, we need to load the view first
        // to determine if there is anything to show in the popover.
        // We won't show it if there isn't anybody that matches.

        return this.getAutoMentionerView('input').then((view) => {
          if (
            view.filterMentionablesForMatches(
              word.str.substring(1).toLowerCase(),
            ).length === 0
          ) {
            PopOver.hide();
            return;
          }

          PopOver.show({
            elem: this.getMentionTarget(),
            view,
            keepEdits: true,
          });

          if (!this.getTextInput().is(':focus')) {
            this.getTextInput().focus();
          }
        });
      } else if (/^:[a-z0-9_]+$/.test(word.str)) {
        const emojiView = this.getEmojiCompleterView('input');

        PopOver.show({
          elem: this.getEmojiTarget(),
          view: emojiView,
          keepEdits: true,
        });

        if (!this.getTextInput().is(':focus')) {
          this.getTextInput().focus();
        }
        return;
      }

      return this.setTimeout(() => PopOver.hide(), 5);
    }
  },
};

export { AutoInsertionView };
